import styled from "styled-components";
import { size } from "styled-system";

import { Image } from "../Image";

const HeaderLogo = styled(Image)`
  display: block;
  ${size}
`;

HeaderLogo.defaultProps = {
  width: [143, null, null, 183],
};

export { HeaderLogo };
